module.exports = {
    'FillBar': require('./fill-bar')
};